import React from 'react';
import PropTypes from 'prop-types';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { BaseWizardStepOverride } from 'Views/Page/Content/Templates/BaseWizardStepOverride';
import ContentWithContext from 'Views/Page/Content/Modal/Layouts/WizardStepLayout/Content';

const AccountOpeningKYCFailStepTemplate = ({ resource }) => {
  const { loadPageContentLink } = usePageContentContext();
  const { prompt, onClick } = resource.withRelationship(
    fr.relationships.messagesPage.name,
    (rel) => ({
      prompt: rel.meta('prompt'),
      onClick() {
        loadPageContentLink(rel.link('related'));
      },
    }),
    () => ({}),
  );

  return (
    <WizardStepWrapperTemplate
      metaOverrideSet={BaseWizardStepOverride}
      resource={resource}
      layout={ContentWithContext}
      onNext={onClick}
      primaryActionLabel={prompt}
    />
  );
};

AccountOpeningKYCFailStepTemplate.defaultProps = {
};

AccountOpeningKYCFailStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default AccountOpeningKYCFailStepTemplate;
